import React from 'react';

import SearchField from '@adsk/alloy-react-search-field';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from './i18n';
import { useCollection } from './providers/CollectionProvider';

const SheetSearchBox = ({ searchExpression, disabled, onSearchChange }) => {
  const { t } = useTranslation();

  const { isFeatureEnabled: enableCollectionFeature } = useCollection();

  if (enableCollectionFeature) return null;

  return (
    <SearchField
      style={{
        width: 300,
        'input:disabled': {
          background: theme.colors.white,
        },
      }}
      placeholder={t('SEARCH')}
      value={searchExpression || ''}
      onChange={onSearchChange}
      disabled={disabled}
    />
  );
};

export default SheetSearchBox;
